import { Summary } from "../components/summary/Summary";
import { Particulars } from "../components/tab-sections/Particulars";
import { NotableItems } from "../components/NotableItems";
import { Grading } from "../components/tab-sections/Grading";
import { Documents } from "../components/tab-sections/Documents";
import { GradeComparison } from "../components/tab-sections/GradeComparison";
import { VesselInspectionDataResponse } from "../types/responses/VesselInspectionDataResponse";
import { Defects } from "../components/Defects";
import { Decarbonisation } from "../components/tab-sections/Decarbonisation";

const getIdTabs = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    return [
        {
            title: t("tabs.summary"),
            content: <Summary documentData={documentData}/>
        },
        {
            title: t("tabs.particulars"),
            content: (
                <Particulars
                    data={vesselInspectionDataResponse.vesselInspectionResponse}
                    isLoading={vesselInspectionDataResponse.isLoading}
                    error={vesselInspectionDataResponse.error}
                    isError={vesselInspectionDataResponse.isError}
                />
            )
        },
        {
            title: t("tabs.grade_comparison"),
            content: (
                <GradeComparison
                    imo={
                        vesselInspectionDataResponse.vesselInspectionResponse
                            ?.IMONumber
                    }
                    vesselGrade={
                        vesselInspectionDataResponse.vesselInspectionResponse
                            ?.Grade
                    }
                />
            )
        },
        {
            title: t("tabs.grading"),
            content: <Grading idReport={true} />
        },
        {
            title: t("tabs.defects"),
            content: <Defects />
        },
        {
            title: t("tabs.decarbonisation"),
            content: <Decarbonisation />
        },
        {
            title: t("tabs.documents"),
            content: <Documents linkTabIndex={7} />
        },
        {
            title: t("tabs.supplements"),
            content: <Documents supplements />
        }
    ];
};

const getDefaultTabs = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    return [
        {
            title: t("tabs.summary"),
            content: <Summary documentData={documentData} />
        },
        {
            title: t("tabs.particulars"),
            content: (
                <Particulars
                    data={vesselInspectionDataResponse.vesselInspectionResponse}
                    isLoading={vesselInspectionDataResponse.isLoading}
                    error={vesselInspectionDataResponse.error}
                    isError={vesselInspectionDataResponse.isError}
                />
            )
        },
        {
            title: t("tabs.notable_items"),
            content: <NotableItems />
        },
        {
            title: t("tabs.grading"),
            content: <Grading idReport={false} />
        },
        {
            title: t("tabs.decarbonisation"),
            content: <Decarbonisation />
        },
        {
            title: t("tabs.documents"),
            content: <Documents linkTabIndex={6} />
        },
        {
            title: t("tabs.supplements"),
            content: <Documents supplements />
        },
        {
            title: t("tabs.grade_comparison"),
            content: (
                <GradeComparison
                    imo={
                        vesselInspectionDataResponse.vesselInspectionResponse
                            ?.IMONumber
                    }
                    vesselGrade={
                        vesselInspectionDataResponse.vesselInspectionResponse
                            ?.Grade
                    }
                />
            )
        }
    ];
};

const getConditionInspectionTabs = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    return [
        {
            title: t("tabs.summary"),
            content: <Summary documentData={documentData}/>
        },
        {
            title: t("tabs.particulars"),
            content: (
                <Particulars
                    data={vesselInspectionDataResponse.vesselInspectionResponse}
                    isLoading={vesselInspectionDataResponse.isLoading}
                    error={vesselInspectionDataResponse.error}
                    isError={vesselInspectionDataResponse.isError}
                />
            )
        },
        {
            title: t("tabs.notable_items"),
            content: <NotableItems />
        },
        {
            title: t("tabs.grading"),
            content: <Grading idReport={false} />
        },
        {
            title: t("tabs.decarbonisation"),
            content: <Decarbonisation />
        },
        {
            title: t("tabs.documents"),
            content: <Documents linkTabIndex={6} />
        },
        {
            title: t("tabs.supplements"),
            content: <Documents supplements />
        }
    ];
};

export const getTabsForInspection = (
    vesselInspectionDataResponse: VesselInspectionDataResponse,
    documentData: any,
    t: any
) => {
    const vesselInspectionResponse =
        vesselInspectionDataResponse.vesselInspectionResponse;
    if (vesselInspectionResponse == undefined) {
        return [];
    }

    switch (vesselInspectionResponse.InspectionType) {
        case "ID Condition Inspection":
            return getIdTabs(vesselInspectionDataResponse, documentData, t);
        case "Condition Inspection":
            return getConditionInspectionTabs(vesselInspectionDataResponse, documentData, t);
        default:
            return getDefaultTabs(vesselInspectionDataResponse, documentData, t);
    }
};
